import {
  FRAME_DEFAULT_HEIGHT,
  FRAME_DEFAULT_WIDTH,
} from "@/lib/frame-defaults";

/** Shared grid metrics for time-page membership and its rendered layout. */
export const CANVAS_TIME_PAGE_GAP_X = 40;
export const CANVAS_TIME_PAGE_GAP_Y = 40;
export const CANVAS_TIME_PAGE_FULL_WIDTH_COLUMNS = 6;
export const CANVAS_TIME_PAGE_ROWS = 3;

export const CANVAS_TIME_PAGE_CELL_WIDTH =
  FRAME_DEFAULT_WIDTH + CANVAS_TIME_PAGE_GAP_X;
export const CANVAS_TIME_PAGE_MAX_CONTENT_HEIGHT =
  CANVAS_TIME_PAGE_ROWS * FRAME_DEFAULT_HEIGHT +
  (CANVAS_TIME_PAGE_ROWS - 1) * CANVAS_TIME_PAGE_GAP_Y;
